export const images = [
    {
        id: 1, 
        src: require('./Assets/gallery1.JPG')
    },
    {
        id: 2, 
        src: require('./Assets/gallery2.JPG')
    },
    {
        id: 3, 
        src: require('./Assets/gallery3.jpg')
    },
    {
        id: 4, 
        src: require('./Assets/gallery4.JPG')
    },
    {
        id: 5, 
        src: require('./Assets/gallery5.PNG')
    },
    {
        id: 6, 
        src: require('./Assets/gallery6.JPG')
    },
    {
        id: 7, 
        src: require('./Assets/gallery7.JPG')
    },
    {
        id: 8, 
        src: require('./Assets/gallery8.JPG')
    },
    {
        id: 9, 
        src: require('./Assets/gallery9.JPG')
    },
    {
        id: 10, 
        src: require('./Assets/gallery10.JPG')
    },
    {
        id: 11, 
        src: require('./Assets/gallery11.jpg')
    },
    {
        id: 12, 
        src: require('./Assets/gallery12.PNG')
    },
    {
        id: 13, 
        src: require('./Assets/gallery13.PNG')
    },
    {
        id: 14,
        src: require('./Assets/gallery14.JPG')
    },
    {
        id: 15,
        src: require('./Assets/gallery15.JPG')
    },
    {
        id: 16,
        src: require('./Assets/gallery16.JPG')
    },
    {
        id: 17,
        src: require('./Assets/gallery17.JPG')
    },
    {
        id: 18,
        src: require('./Assets/gallery18.JPG')
    },
    {
        id: 19,
        src: require('./Assets/gallery19.JPG')
    },
];